module.exports = __webpack_public_path__ + "media/images/pic/hero/sun-b5bf0426d200eb07be78ff8bc3190428.webp";